import { createSlice } from "@reduxjs/toolkit";
import {
  getMongoUsageThunk,
  getMediaUsageThunk,
  getTwilioUsageThunk,
} from "../thunks/usageThunks";

const initialState = {
  services: {
    mongo: {
      usage: {},
      limits: {},
      // otherFields...
    },
    media: {
      usage: {},
      limits: {},
      // otherFields...
    },
    twilio: {
      usage: {},
      limits: {},
      // otherFields...
    },
  },
  loading: false,
  error: null,
};

const usageSlice = createSlice({
  name: "usage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // MongoDB Usage
      .addCase(getMongoUsageThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMongoUsageThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.services.mongo.usage = action.payload.usage;
        state.services.mongo.limits = action.payload.limits;
      })
      .addCase(getMongoUsageThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Media Usage
      .addCase(getMediaUsageThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMediaUsageThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.services.media.usage = action.payload.usage;
        state.services.media.limits = action.payload.limits;
      })
      .addCase(getMediaUsageThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Twilio Usage
      .addCase(getTwilioUsageThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTwilioUsageThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.services.twilio.usage = action.payload.usage;
        state.services.twilio.limits = action.payload.limits;
        state.services.twilio.enabled = action.payload.enabled;
      })
      .addCase(getTwilioUsageThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default usageSlice.reducer;
